// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__2DQrj","sendOtp":"AuthorizeToLogin_sendOtp__3HmSx"};